import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { ITimelineGroup } from './models/timeline-group';

@Component({
    selector: 'aa-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: [
        './timeline.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimelineComponent implements OnInit
{
    @Input() tlGroups: ITimelineGroup[];

    constructor() { }

    ngOnInit ()
    {
    }

}
